import AxiosService from "./axiosServices";

const BASE_VIZ_URL = process.env.REACT_APP_R_APIBASE;

const VisualizationService = {
  getPlotData: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}generate_multi_plot`,
      payload,
    ).then((res) => res.data);
  },

  fetchProductsSitesAndUnitOfOperations: () => {
    return AxiosService.Get("api/cam/srm/base-filter/").then((res) => res.data);
  },

  fetchParameterList: (payload) => {
    return AxiosService.Post(`${BASE_VIZ_URL}parameter_listing`, payload).then(
      (res) => res.data,
    );
  },

  fetchFilteredBatchList: (payload) => {
    return AxiosService.Post(`${BASE_VIZ_URL}batch_preview`, payload).then(
      (res) => res.data,
    );
  },

  fetchSavedVizList: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}get_saved_multi_viz_details`,
      payload,
    ).then((res) => res.data);
  },

  getFolders: (params) => {
    return AxiosService.Get("api/cam/folder-list/", { params }).then(
      (res) => res.data,
    );
  },

  saveVisualization: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}save_visualization_multichart`,
      payload,
    ).then((res) => res.data);
  },

  fetchSavedVisualization: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}load_saved_multi_viz`,
      payload,
    ).then((res) => res.data);
  },
};

export default VisualizationService;
